import React, { useEffect, useState } from "react";
import { Form, Switch, Upload, Button } from "antd";
import { Col, Container, Row } from "react-bootstrap";
import { UploadOutlined } from "@ant-design/icons";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";
import Notification from "../../services/Notification";

const Settings = () => {
  const [active, setActive] = useState(true);
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    try {
      (async () => {
        let data = await axios.get("/settings-list").catch((error) => {
          Helper.ErrorHanlder(error);
        });

        if (data && data.data) {
          setActive(data.data.data.points);
          setFileList(data.data.data.offersBanner);
        }
      })();
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
    // eslint-disable-next-line
  }, []);

  const imageUpload = async ({ file, onSuccess }) => {
    var formData = new FormData();
    formData.append("image", file);
    let data = await axios
      .post("settings-upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .catch((error) => {
        Helper.ErrorHanlder(error);
      });
    if (data && data.data) {
      onSuccess("ok");
    }
  };

  const handleBeforeUpload = (file) => {
    const newName = generateFileName(file.name, "TCT_Price_List");
    const newFile = new File([file], newName, { type: file.type });
    return newFile;
  };

  const handleBeforeLogoUpload = (file) => {
    const newName = generateFileName(file.name, "Logo");
    const newFile = new File([file], newName, { type: file.type });
    return newFile;
  };

  const handleBeforeVideo = (file) => {
    const newName = generateFileName(file.name, "video");
    const newFile = new File([file], newName, { type: file.type });
    return newFile;
  };

  const handleBeforeUploadAD = (file) => {
    const newName = generateFileName(file.name, "AD");
    const newFile = new File([file], newName, { type: file.type });
    return newFile;
  };

  const generateFileName = (originalName, name) => {
    const extension = originalName.split(".").pop();
    return `${name}.${extension}`;
  };

  const onChange = async (checked) => {
    try {
      setActive(checked);
      let obj = { points: checked };
      const data = await axios
        .patch("/update-points-settings", obj)
        .catch((error) => {
          Helper.ErrorHanlder(error);
        });
      if (data && data.data) {
        Notification.success("Updated");
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  const BannerImageUpload = async ({ file, onSuccess }) => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      const { data } = await axios.post("web-image-upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (data && data?.files?.[0]) {
        const filename = data.files[0];

        setFileList((prev) => [...prev, filename]);

        onSuccess("ok");
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  const handleUploadAll = async () => {
    try {
      const res = await axios.post("settings-create", {
        offersBanner: fileList,
      });
      Notification.success("Banners Uploaded Successfully");
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  return (
    <Container fluid>
      <div className="settings-pg">
        <Row>
          <Col md={12}>
            <Form layout={"vertical"}>
              <Form.Item label="Logo" name="logo">
                <Upload
                  customRequest={imageUpload}
                  beforeUpload={handleBeforeLogoUpload}
                  listType="picture"
                  defaultFileList={[]}
                >
                  <Button icon={<UploadOutlined />}>Upload</Button>
                </Upload>
              </Form.Item>
              <Form.Item label="Price PDF" name="pricePdf">
                <Upload
                  customRequest={imageUpload}
                  beforeUpload={handleBeforeUpload}
                  listType="picture"
                  defaultFileList={[]}
                >
                  <Button icon={<UploadOutlined />}>Upload</Button>
                </Upload>
              </Form.Item>
              <Form.Item label="Banners">
                <Upload
                  customRequest={BannerImageUpload}
                  listType="picture"
                  multiple
                  name="image"
                  maxCount={3}
                  fileList={fileList.map((fileName, index) => ({
                    uid: `${index}`,
                    name: fileName,
                    status: "done",
                    url: `https://thecharmingtreasure.in/uploads/${fileName}`,
                  }))}
                  onRemove={async (file) => {
                    try {
                      const filename = file.name;

                      await axios.post("/delete-image", { filename });

                      // Update state to remove deleted file
                      setFileList((prev) =>
                        prev.filter((name) => name !== filename)
                      );

                      return true;
                    } catch (error) {
                      Notification.error("Failed to delete image");
                      return false;
                    }
                  }}
                >
                  <Button icon={<UploadOutlined />}>Upload</Button>
                </Upload>
                <Button
                  onClick={handleUploadAll}
                  type="primary"
                  style={{ marginTop: 16 }}
                >
                  Upload Selected Images
                </Button>
              </Form.Item>
              <Form.Item label="Video">
                <Upload
                  customRequest={imageUpload}
                  beforeUpload={handleBeforeVideo}
                  listType="picture"
                  maxCount={1}
                  defaultFileList={[]}
                >
                  <Button icon={<UploadOutlined />}>Upload Video</Button>
                </Upload>
              </Form.Item>
              <Form.Item label="AD">
                <Upload
                  customRequest={imageUpload}
                  beforeUpload={handleBeforeUploadAD}
                  listType="picture"
                  maxCount={1}
                  defaultFileList={[]}
                >
                  <Button icon={<UploadOutlined />}>Upload AD</Button>
                </Upload>
              </Form.Item>
              <Form.Item label="Points Settings" name="points">
                <Switch onChange={onChange} checked={active} />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Settings;
